import { Injectable } from '@angular/core';
import { Observable } from 'rxjs'; 
import 'rxjs/Rx';  
import { AwsEndpoints } from './api.aws.request'; 

@Injectable()
export class IntakeApi {
    constructor(api: AwsEndpoints) { 
    this._api = api};

    relativeUrl: string;
    _api: AwsEndpoints;   
 

    //AWS API GATEWAY/////

    // DEV-5544
    // Original V2 Endpoint: /v2/intake/allergy/{intakeId}
    public getIntakeAllergens(intakeId): Observable<any> {
        let res = this._api.awsRequest<any>(HttpMethods.get,
            `intakes/${intakeId}/allergies`)
            .map((response) => {
                return this._api.camelCaseResult(response.result);
            });
            return res;
    }

    // DEV-5556
    // Original V2 Endpoint: /v2/admin/labowork/{intakeId}/patient
    public checkLabworkForPatient(intakeId): Observable<any> {
        let res = this._api.awsRequest<any>(HttpMethods.get,
            `intakes/${intakeId}/labwork`);
        return res;
    }
}


export class HttpMethods {
  static get = 'GET';
  static post = 'POST';
  static patch = 'PATCH';
  static put = 'PUT';
  static delete = 'DELETE';
}